import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AdminSidebar } from '../../components/admin/AdminSidebar';
import { AdminTopbar } from '../../components/admin/AdminTopbar';
import { getAuthToken } from '../../lib/api';

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    const token =
      typeof window !== 'undefined' ? getAuthToken() : null;
    if (!token) {
      const next = encodeURIComponent(
        `${location.pathname}${location.search}`,
      );
      navigate(`/admin/login?next=${next}`, {
        replace: true,
      });
      return;
    }
    document.title = 'Admin · Alex Hidden Gems';
    setChecked(true);
  }, [navigate, location.pathname, location.search]);
  if (!checked) {
    return (
      <div className="min-h-screen bg-[#FCFAF8] flex items-center justify-center">
        <div className="text-sea-blue/80 text-sm font-medium tracking-wide">
          Loading admin…
        </div>
      </div>);

  }
  return (
    <div className="min-h-screen bg-[#FCFAF8] flex font-sans selection:bg-cyan-500/30">
      <AdminSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />

      <div className="flex-grow flex flex-col min-w-0">
        <AdminTopbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-grow p-4 sm:p-6 lg:p-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>);

}